import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { ReplacementLoca } from "../../utils/i18n/ReplacementLoca";
import { utilNumber } from "../../utils/utilNumber";
import { TextLoca } from "../generic/text/TextLoca";
export var StoreItemTitle = function (_a) {
    var item = _a.item;
    var _b = item.balancing, locaKey = _b.locaKey, resourceReward = _b.resourceReward;
    var title = React.createElement(TextLoca, { id: locaKey });
    if (resourceReward) {
        var locaReplacements = new Map([
            [ReplacementLoca.zero_0, utilNumber.format(resourceReward[0].amount)],
        ]);
        title = React.createElement(TextLoca, { id: locaKey, replacements: locaReplacements });
    }
    return (React.createElement("div", { className: IdStyles.TextButtonHeading + " " + IdStyles.TextAlignCenter }, title));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/store/StoreItemTitle.tsx
// module id = 2764
// module chunks = 3